
import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { actions } from "../../../../store/modules";
import i18n from "../../../../plugins/i18n/i18n";
import { errorMessageNotification } from "../../../../helpers";
import { Row, Col, Button, Avatar, Modal, Input, Result, notification as Notification } from 'antd';

const { TextArea } = Input;

class TripApproverView extends Component {

    constructor(props) {
        super(props);
        this.state = {
            isModalOpen: false,
            operationType: null,
            message: null,
            loadings: {
                submit: false
            },
            isSuccess: false
        };
    }

    componentWillMount() {
    }

    toggleModal = (operationType) => {
        this.setState({ isModalOpen: !this.state.isModalOpen, operationType }, () => {
            if (this.state.isSuccess && !this.state.isModalOpen) {
                this.props.fetchData()
            }
        })
    }

    onChangeTextArea = (e) => {
        this.setState({ message: e.target.value })
    }

    gotoHomepage = () => {
        this.props.gotoHomepage()
    }

    gotoPendingTrips = () => {
        this.props.gotoPendingTrips()
    }

    fetch = () => {

        let endpoint = { keyOne: "trip", keyTwo: "vendortripapproval" };

        let { loadings, message, operationType } = this.state;

        loadings.submit = true;
        this.setState({ loadings });


        this.props
            .dispatch(
                actions.definitions.addData({
                    ...endpoint,
                    data: {
                        tripId: this.props.tripId,
                        message: message,
                        status: operationType

                    },
                })
            )
            .then(() => {
                loadings.submit = false;

                this.setState({
                    loadings, isSuccess: true
                });
            })
            .catch((error) => {
                loadings.submit = false;
                this.setState({ loadings });

                Notification.error({
                    message: i18n.t(`error`, {
                        lng: this.props.currentLanguage,
                    }),
                    description: errorMessageNotification(error),
                    className: "general-notification",
                    placement: "bottomLeft",
                    duration: 100,
                });

                setTimeout(() => {
                    Notification.destroy();
                }, 3000);
            });
    };



    render() {

        let { isModalOpen, operationType, isSuccess, loadings } = this.state
        let { data } = this.props

        return (

            <div className='approver-view'>
                <Row className='approver-view-container' style={{width : "100% !important"}}>
                    
                    <Col xs={12} sm={6} md={6} lg={6} xl={6}>

                        {
                            data.owner &&
                            <Fragment>
                                {
                                    data.owner.picturePath ?
                                        <Avatar
                                            src={data.owner.picturePath}
                                            size={50}
                                        /> :
                                        <Avatar
                                            src={"/assets/img/icons/empty-avatar.png"}
                                            size={50}
                                        />
                                }
                                <div class="owner-info">
                                    <div className='subject'>TALEP SAHİBİ</div>
                                    <div className='description'>{data.owner.nameLastname}</div>
                                </div>

                            </Fragment>
                        }

                    </Col>
                    <Col xs={12} sm={6} md={6} lg={6} xl={6}>
                        <div class="owner-info">
                            <div className='subject'>Bu seyahat onayınınızı bekliyor.</div>
                        </div>
                    </Col>
                    <Col xs={12} sm={6} md={6} lg={6} xl={6} style={{ paddingRight: 10 }}>
                        <Button
                            htmlType="submit"
                            type="default"
                            className="ant-btn-red width-100"
                            style={{ height: 40 }}
                            onClick={() => this.toggleModal("declined")}

                        >
                            REDDET
                        </Button>
                    </Col>
                    <Col xs={12} sm={6} md={6} lg={6} xl={6} style={{ paddingRight: 10 }}>

                        <Button
                            htmlType="submit"
                            type="primary"
                            className="ant-btn width-100"
                            style={{ height: 40 }}
                            onClick={() => this.toggleModal("approved")}
                        >
                            ONAYLA
                        </Button>

                    </Col>
                </Row>

                <Modal
                    className=''
                    title={operationType === "approved" ? "Talebi Onaylıyorsunuz" : "Talebi Reddediyorsunuz"}
                    centered open={isModalOpen}
                    onCancel={this.toggleModal}
                    maskClosable={false}
                    destroyOnClose={true}
                    width={550}
                    footer={[
                        !isSuccess &&
                        <Button onClick={this.toggleModal}
                            key={"cancel"}>
                            İptal
                        </Button>,
                        !isSuccess && operationType === "approved" &&
                        <Button type='primary' onClick={() => this.fetch()}
                            loading={loadings.submit}
                            key={"approve"}
                        >
                            Onayla
                        </Button >,
                        !isSuccess && operationType === "declined" &&
                        <Button type='danger' onClick={() => this.fetch()}
                            loading={loadings.submit}
                            className='ant-btn-red'
                            key={"declined"}
                        >
                            Reddet
                        </Button >
                    ]}
                >

                    {
                        isSuccess &&
                        <Result
                            status="success"
                            title={operationType === "approved" ? "Bu talebi onayladınız" : "Bu talebi reddettiniz"}
                            extra={[
                                <Button key="pending"
                                    type='dashed'
                                    onClick={() => this.gotoPendingTrips()}
                                >
                                    Bekleyen Diğer Talepleri Gör
                                </Button>,
                                <Button key="home"
                                    type='dashed'
                                    onClick={() => this.gotoHomepage()}
                                >
                                    Ana Sayfaya Dön
                                </Button>
                            ]}
                        />
                    }

                    {
                        !isSuccess &&
                        <TextArea rows={4} placeholder="Bu talep için talep notu girebilirsiniz."
                            onChange={(e) => this.onChangeTextArea(e)}

                        />
                    }


                </Modal>
            </div>


        );
    }
}

const mapStateToProps = ({ account }) => ({ ...account });
export default connect(mapStateToProps)(TripApproverView);


// WEBPACK FOOTER //
// ./src/components/App/Views/Trip/TripApproverView.js